import { useSchemaList } from '../../../hooks/useSchemaList';
import SchemaCreateForm from '../components/SchemaCreateForm';
import SchemaApi from '../../../api/schemaApi';
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import SchemasTable from '../components/SchemasTable';
import SchemaDeleteDialog from '../components/SchemaDeleteDialog';
import { AppErrorList, useAppErrorList } from '../../../shared/components/AppErrorList';

interface DialogOptions {
  readonly isOpen: boolean;
  readonly schemaName: string;
}

const INITIAL_DIALOG_OPTIONS: DialogOptions = {
  isOpen: false,
  schemaName: '',
};

const SchemasContainer = () => {
  const [{ schemas, isLoading, errors: loadingSchemasErrors }, { refreshAll }] = useSchemaList();
  const [{ errors, hasErrors }, { addError, setErrors }] = useAppErrorList();

  const [dialogOptions, setDialogOptions] = useState<DialogOptions>(INITIAL_DIALOG_OPTIONS);

  const openDialog = (schemaName: string) => setDialogOptions({ isOpen: true, schemaName });
  const closeDialog = () => setDialogOptions(INITIAL_DIALOG_OPTIONS);

  const handleAddSchema = (schemaName: string) => {
    SchemaApi.createEmptySchema(schemaName)
      .then(() => refreshAll())
      .catch(addError);
  };

  const handleCloneSchema = (sourceSchemaName: string, schemaName: string) => {
    SchemaApi.cloneSchema(sourceSchemaName, schemaName)
      .then(() => refreshAll())
      .catch(addError);
  };

  const handleDeleteSchema = (schemaName: string) => {
    SchemaApi.deleteSchema(schemaName)
      .then(() => {
        closeDialog();
        refreshAll();
      })
      .catch(addError);
  };

  useEffect(() => {
    setErrors(loadingSchemasErrors);
  }, [setErrors, loadingSchemasErrors]);

  return (
    <Grid container spacing={5}>
      { hasErrors && (
        <Grid item md={12}>
          <AppErrorList errors={errors} />
        </Grid>
      )}

      <Grid item md={3}>
        <SchemaCreateForm
          schemas={schemas}
          onAddSchema={handleAddSchema}
          onCloneSchema={handleCloneSchema}
        />
      </Grid>

      <Grid item md={9}>
        <SchemasTable
          schemas={schemas}
          isLoading={isLoading}
          onDeleteClick={openDialog}
        />
      </Grid>

      <SchemaDeleteDialog
        isOpen={dialogOptions.isOpen}
        schemaName={dialogOptions.schemaName}
        onConfirmClick={() => handleDeleteSchema(dialogOptions.schemaName)}
        onCancelClick={closeDialog}
      />
    </Grid>
  );
};

export default SchemasContainer;
